import Collection from '../../../collection';
import View from '../../view';

import { get } from '../../../http/api';
import { hashify } from '../../../utils/arrays';





export default View.extend( {

    serialize() {
        const { layers, group: { objects, types } } = this.options;
        const layersHash = hashify( layers, layer => [layer.id, layer] );

        return {
            types,
            objects: objects.map( ({ layer_id, ...attrs }) => ({
                layer: layersHash[layer_id],
                ...attrs,
            }) ),
        };
    },

} );








// WEBPACK FOOTER //
// ./src/js/view/module/contracts/group.js